import { render, staticRenderFns } from "./product_management.vue?vue&type=template&id=37354be0&scoped=true"
import script from "./product_management.vue?vue&type=script&lang=js"
export * from "./product_management.vue?vue&type=script&lang=js"
import style0 from "./product_management.vue?vue&type=style&index=0&id=37354be0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37354be0",
  null
  
)

export default component.exports